<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <span v-html="formatCountLicenses">
        </span>
        <v-layout row wrap align-left justify-center>
          <template v-for="item in topItems">
            <v-flex px-2>    
              <b><a v-if="!getImageUrl(item)" @click="dialogOpen(item)">{{item.registrationNumber}}</a></b>
              <b><a v-if="getImageUrl(item) && item.sound" @click="dialogOpen(item)">Звук<br/> {{item.registrationNumber}}</a></b>
              <a v-if="getImageUrl(item) && !item.sound" @click="dialogOpen(item)">
              <img style="max-height:120px" :src="getImageUrl(item)"/>
              </a>
            </v-flex>
         </template>
       </v-layout>
      </div>
    </v-panel-title>
    <v-card-text v-if="isLoaded && lastItems.length > 0" class="pt-0">
        <v-layout row wrap align-center>
          <template v-for="item in lastItems">
            <v-flex px-2>    
              <b><a v-if="!getImageUrl(item)" @click="dialogOpen(item)">{{item.registrationNumber}}</a></b>
              <a v-if="getImageUrl(item)" @click="dialogOpen(item)">
              <img style="max-height:120px" v-if="getImageUrl(item)" :src="getImageUrl(item)"/>
              </a>
            </v-flex>
         </template>
       </v-layout>
    </v-card-text>    
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'
  import vTrademarkForm from './TrademarkForm'
  import dialogs from '../common/dialogs'

  export default {
    name: 'v-trademarks-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      items: [],
      topCount: 5,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      if (this.ogrn) {
        this.id = this.ogrn
        this.fetchItems()
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderDateSince: 'renderDateSince'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      },
      formatCountLicenses () {
        return ''.concat(
          'Товарных знаков ',
          this.items ? this.items.length : 0
          )
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      sortItems (a, b) {
        var result = 0
        if (!result) {
          result = new Date(a.registrationDate).getTime() - new Date(b.registrationDate).getTime()
        }
        return result
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о лицензиях '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/trademarks',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.isLoading = false
            this.items = data
            this.items.sort((a, b) => this.sortItems(a, b))
          })
        }
      },
      dialogOpen: function (item) {
        dialogs.register('v-trademark-form', vTrademarkForm)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-trademark-form v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-trademark-form>
        `,
          data () {
            return {
              model: item,
              fullscreen: fullscreen
            }
          }
        }
        dialogs.modal(comp)
      },
      getImageUrl (item) {
        if (!item || !item.imageUrl) {
          return null
        }
        return `${server.getBaseUrl()}/openapi/trademarks/${item.registrationNumber}/preview`
      }
    }
  }

</script>



// WEBPACK FOOTER //
// TrademarksPanel.vue?1020533e